<template>
  <el-dialog
    title="选择仓库"
    :visible.sync="visible"
    width="640px"
    append-to-body=""
    @closed="handleClosed">
    <div class="search-form">
      <el-input
        v-model="config.warehouseName"
        placeholder="请输入仓库名称"
        style="width: 200px"
        clearable=""
        class="input-with-select">
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="handleCurrentChange(1)"></el-button>
      </el-input>
    </div>
    <el-table
      v-loading="loading"
      border
      highlight-current-row
      :data="list"
      @current-change="handleCurrentRowChange">
      <el-table-column
        label=""
        :resizable="false"
        width="30">
        <template slot-scope="{row}">
          <el-radio
            v-model="current.warehouseId"
            :label="row.warehouseId">&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column
        label="仓库名称"
        :resizable="false"
        prop="warehouseName"></el-table-column>
      <el-table-column
        label="仓库编号"
        width="100"
        :resizable="false"
        prop="warehouseNo"></el-table-column>
      <el-table-column
        width="250"
        :resizable="false"
        label="所属部门(公司)"
        prop="departmentName"></el-table-column>
    </el-table>
    <pagination-new
      v-model="config"
      :total="total"
      :fetch="fetchList" />
    <div slot="footer">
      <el-button @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        @click="add">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'WarehouseSelectModal',
  components: {},
  props: {
    callback: Function,
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      list: [],
      visible: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        warehouseName: ''
      },
      options: {},
      total: 0,
      current: {}
    }
  },
  watch: {
    current: {
      handler(val) {
        console.log(val)
      },
      deep: true
    }
  },
  created() { },
  mounted() { },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.list = []
      this.current = {}
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    add() {
      if (!this.current.warehouseId) {
        this.$message.error('请选择一个仓库')
        return
      }
      this.callback && this.callback(this.current)
      if (this.autoClose) {
        this.toggleModal(false)
      }
    },
    handleCurrentRowChange(row) {
      this.current = row || {}
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('outstock/getwarehouses', {
        payload: {
          ...this.config,
          ...this.options
        },
        success: res => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch(options) {
      this.options = options
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.search-form {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>
